var map = {
	"./boss-dlc.png": 303,
	"./bow.png": 3489,
	"./calamity.png": 1520,
	"./camera-elite.png": 2000,
	"./camera-plus.png": 6363,
	"./chest-special.png": 9966,
	"./chest.png": 7615,
	"./cook.png": 3342,
	"./equipment.png": 1351,
	"./ganon.png": 1130,
	"./hestu.png": 8742,
	"./hinox-black.png": 3028,
	"./hinox-blue.png": 9001,
	"./hinox-red.png": 8562,
	"./hinox-stal.png": 5008,
	"./house-plus.png": 7653,
	"./king.png": 3011,
	"./korok-acorn-flying.png": 5722,
	"./korok-acorn.png": 2005,
	"./korok-balloon.png": 3534,
	"./korok-basketball.png": 487,
	"./korok-confetti.png": 6276,
	"./korok-flower.png": 1334,
	"./korok-golf-boulder.png": 604,
	"./korok-golf-snowball.png": 4371,
	"./korok-ice.png": 5899,
	"./korok-light-chase.png": 8126,
	"./korok-lily.png": 6584,
	"./korok-magnesis.png": 3874,
	"./korok-matching.png": 1409,
	"./korok-minus.png": 2482,
	"./korok-offer-apple.png": 9542,
	"./korok-offer-banana.png": 214,
	"./korok-offer-durian.png": 8895,
	"./korok-offer-egg.png": 1501,
	"./korok-race.png": 9442,
	"./korok-rock-circle.png": 3184,
	"./korok-rock-tree.png": 6046,
	"./korok-rock-under.png": 7800,
	"./korok-rock.png": 4319,
	"./korok-shoot.png": 677,
	"./korok.png": 5934,
	"./link.png": 6622,
	"./location.png": 1736,
	"./make-morning.png": 6733,
	"./make-night.png": 9488,
	"./make-noon.png": 3543,
	"./master-cycle.png": 7191,
	"./material.png": 6690,
	"./maz.png": 1399,
	"./medoh-done.png": 3306,
	"./medoh-enter.png": 9279,
	"./medoh-memory.png": 9788,
	"./medoh-plus.png": 9546,
	"./memory-final.png": 491,
	"./memory.png": 1054,
	"./molduga.png": 2181,
	"./naboris-done.png": 9649,
	"./naboris-enter.png": 5818,
	"./naboris-memory.png": 5512,
	"./naboris-plus.png": 4883,
	"./npc-gerudo.png": 2218,
	"./npc-goron.png": 7117,
	"./npc-rito.png": 8238,
	"./npc-sheika-female.png": 1664,
	"./npc-sheika-male.png": 6626,
	"./npc-zora-female.png": 7803,
	"./npc-zora-male.png": 1872,
	"./npc.png": 2079,
	"./rudania-done.png": 546,
	"./rudania-enter.png": 555,
	"./rudania-memory.png": 8610,
	"./rudania-plus.png": 1838,
	"./ruta-done.png": 4996,
	"./ruta-enter.png": 8015,
	"./ruta-memory.png": 7966,
	"./ruta-plus.png": 6707,
	"./shield.png": 1575,
	"./shop.png": 4869,
	"./shrine-blessing.png": 6493,
	"./shrine-dlc.png": 3720,
	"./shrine-double-sword.png": 5650,
	"./shrine-sword.png": 3951,
	"./shrine.png": 2442,
	"./snap.png": 5229,
	"./sor.png": 1392,
	"./talus-frost-rare.png": 6167,
	"./talus-igneo-rare.png": 3793,
	"./talus-luminous.png": 6377,
	"./talus-rare.png": 8509,
	"./talus.png": 9396,
	"./tots.png": 3787,
	"./tower.png": 4557,
	"./warp.png": 7845,
	"data/image/boss-dlc.png": 303,
	"data/image/bow.png": 3489,
	"data/image/calamity.png": 1520,
	"data/image/camera-elite.png": 2000,
	"data/image/camera-plus.png": 6363,
	"data/image/chest-special.png": 9966,
	"data/image/chest.png": 7615,
	"data/image/cook.png": 3342,
	"data/image/equipment.png": 1351,
	"data/image/ganon.png": 1130,
	"data/image/hestu.png": 8742,
	"data/image/hinox-black.png": 3028,
	"data/image/hinox-blue.png": 9001,
	"data/image/hinox-red.png": 8562,
	"data/image/hinox-stal.png": 5008,
	"data/image/house-plus.png": 7653,
	"data/image/king.png": 3011,
	"data/image/korok-acorn-flying.png": 5722,
	"data/image/korok-acorn.png": 2005,
	"data/image/korok-balloon.png": 3534,
	"data/image/korok-basketball.png": 487,
	"data/image/korok-confetti.png": 6276,
	"data/image/korok-flower.png": 1334,
	"data/image/korok-golf-boulder.png": 604,
	"data/image/korok-golf-snowball.png": 4371,
	"data/image/korok-ice.png": 5899,
	"data/image/korok-light-chase.png": 8126,
	"data/image/korok-lily.png": 6584,
	"data/image/korok-magnesis.png": 3874,
	"data/image/korok-matching.png": 1409,
	"data/image/korok-minus.png": 2482,
	"data/image/korok-offer-apple.png": 9542,
	"data/image/korok-offer-banana.png": 214,
	"data/image/korok-offer-durian.png": 8895,
	"data/image/korok-offer-egg.png": 1501,
	"data/image/korok-race.png": 9442,
	"data/image/korok-rock-circle.png": 3184,
	"data/image/korok-rock-tree.png": 6046,
	"data/image/korok-rock-under.png": 7800,
	"data/image/korok-rock.png": 4319,
	"data/image/korok-shoot.png": 677,
	"data/image/korok.png": 5934,
	"data/image/link.png": 6622,
	"data/image/location.png": 1736,
	"data/image/make-morning.png": 6733,
	"data/image/make-night.png": 9488,
	"data/image/make-noon.png": 3543,
	"data/image/master-cycle.png": 7191,
	"data/image/material.png": 6690,
	"data/image/maz.png": 1399,
	"data/image/medoh-done.png": 3306,
	"data/image/medoh-enter.png": 9279,
	"data/image/medoh-memory.png": 9788,
	"data/image/medoh-plus.png": 9546,
	"data/image/memory-final.png": 491,
	"data/image/memory.png": 1054,
	"data/image/molduga.png": 2181,
	"data/image/naboris-done.png": 9649,
	"data/image/naboris-enter.png": 5818,
	"data/image/naboris-memory.png": 5512,
	"data/image/naboris-plus.png": 4883,
	"data/image/npc-gerudo.png": 2218,
	"data/image/npc-goron.png": 7117,
	"data/image/npc-rito.png": 8238,
	"data/image/npc-sheika-female.png": 1664,
	"data/image/npc-sheika-male.png": 6626,
	"data/image/npc-zora-female.png": 7803,
	"data/image/npc-zora-male.png": 1872,
	"data/image/npc.png": 2079,
	"data/image/rudania-done.png": 546,
	"data/image/rudania-enter.png": 555,
	"data/image/rudania-memory.png": 8610,
	"data/image/rudania-plus.png": 1838,
	"data/image/ruta-done.png": 4996,
	"data/image/ruta-enter.png": 8015,
	"data/image/ruta-memory.png": 7966,
	"data/image/ruta-plus.png": 6707,
	"data/image/shield.png": 1575,
	"data/image/shop.png": 4869,
	"data/image/shrine-blessing.png": 6493,
	"data/image/shrine-dlc.png": 3720,
	"data/image/shrine-double-sword.png": 5650,
	"data/image/shrine-sword.png": 3951,
	"data/image/shrine.png": 2442,
	"data/image/snap.png": 5229,
	"data/image/sor.png": 1392,
	"data/image/talus-frost-rare.png": 6167,
	"data/image/talus-igneo-rare.png": 3793,
	"data/image/talus-luminous.png": 6377,
	"data/image/talus-rare.png": 8509,
	"data/image/talus.png": 9396,
	"data/image/tots.png": 3787,
	"data/image/tower.png": 4557,
	"data/image/warp.png": 7845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8112;